import { useSyncExternalStore } from 'react';
import { config } from '../config';

const UNAVAILABLE = Object.freeze({
  status: 'unavailable', gdprApplies: null, adsReady: false, isBusy: false,
  settingsAvailable: false, siteConsentOpen: false,
});
const BYPASS = Object.freeze({
  ...UNAVAILABLE, status: 'not_required', adsReady: true,
});

const isEnabled = () => String(config.ENVIRONMENT || '').trim().toLowerCase() === 'production'
  && process.env.REACT_APP_IS_ADMIN_PORTAL !== 'true';
const coordinator = () => (typeof window !== 'undefined' ? window.__GDP_GOOGLE_CMP__ : null);

export const getGoogleCmpSnapshot = () => (
  isEnabled() ? coordinator()?.getSnapshot() || UNAVAILABLE : BYPASS
);
const subscribe = (listener) => (
  isEnabled() ? coordinator()?.subscribe(listener) || (() => {}) : () => {}
);

export const useGoogleCmp = () => useSyncExternalStore(subscribe, getGoogleCmpSnapshot, getGoogleCmpSnapshot);
export const canRequestGoogleAds = () => getGoogleCmpSnapshot().adsReady;
export const canShowGoogleInterstitial = () => {
  const state = getGoogleCmpSnapshot();
  return state.adsReady && !state.siteConsentOpen;
};
export const setSiteConsentOpen = (open) => {
  if (isEnabled()) coordinator()?.setSiteConsentOpen(open);
};
export const openAdvertisingSettings = () => coordinator()?.openAdvertisingSettings() || false;
